import { render, staticRenderFns } from "./audit-site-web.vue?vue&type=template&id=8c455138&scoped=true&"
import script from "./audit-site-web.vue?vue&type=script&lang=js&"
export * from "./audit-site-web.vue?vue&type=script&lang=js&"
import style0 from "./audit-site-web.vue?vue&type=style&index=0&id=8c455138&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c455138",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Audit: require('/app/components/Audit.vue').default,Button: require('/app/components/Button.vue').default,BeAdvised: require('/app/components/BeAdvised.vue').default,FaqRefonte: require('/app/components/FaqRefonte.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
